import { Link, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { LocaleSwitcher } from "@/app/layouts/LocaleSwitcher";
import { SessionNav } from "@/app/layouts/SessionNav";

export function PublicLayout() {
  const { t } = useTranslation(["common", "legal"]);

  return (
    <div className="flex min-h-dvh flex-col">
      {/* Premier élément focalisable : exigence WCAG pour la navigation clavier. */}
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:rounded focus:bg-white focus:px-3 focus:py-2 focus:shadow dark:focus:bg-slate-900"
      >
        {t("nav.skipToContent")}
      </a>

      <header className="border-b border-slate-200 dark:border-slate-800">
        <nav
          aria-label={t("nav.home")}
          className="mx-auto flex max-w-4xl items-center justify-between px-4 py-4"
        >
          <Link to="/" className="text-lg font-semibold">
            {t("app.name")}
          </Link>
          <div className="flex items-center gap-4">
            <SessionNav />
            <LocaleSwitcher />
          </div>
        </nav>
      </header>

      <main id="main" className="mx-auto w-full max-w-4xl flex-1 px-4 py-10">
        <Outlet />
      </main>

      <footer className="border-t border-slate-200 py-6 dark:border-slate-800">
        {/* Les pages légales vivent ici et nulle part ailleurs : le pied de page
            est l'endroit où on les cherche, et les mettre dans la navigation
            principale les rendrait plus visibles que les cours. */}
        <div className="mx-auto flex max-w-4xl flex-col gap-3 px-4 text-sm text-slate-500 sm:flex-row sm:items-center sm:justify-between dark:text-slate-400">
          <p>
            {t("app.name")} — {t("app.tagline")}
          </p>
          <nav aria-label={t("nav.legal")} className="flex flex-wrap gap-4">
            <Link to="/legal/terms" className="hover:underline">
              {t("legal:nav.terms")}
            </Link>
            <Link to="/legal/privacy" className="hover:underline">
              {t("legal:nav.privacy")}
            </Link>
            <Link to="/legal/notice" className="hover:underline">
              {t("legal:nav.notice")}
            </Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}
